(function injectWishlistStyles() {
  const css = `
    .page-width.page-width--narrow,
    .template-page .page-width,
    .template-page .page-width--narrow,
    #shopify-section-template--19852424413346__main,
    #shopify-section-template--19852424413346__main > div {
      max-width: 100% !important;
      width: 100% !important;
      padding-left: 5% !important;
      padding-right: 3px !important;
      box-sizing: border-box !important;
    }
     #wishlist-container .wl-grid {
    display: grid !important;
   
    gap: 4px !important;
    width: 110% !important;
    margin: 0 !important;
    padding: 0 !important;
  }


  .wl-cart-overlay{
  position:absolute;
  bottom:8px;
  right:8px;
  z-index:10;
  display:flex;
}
    .wl-btn-cart-icon{
  width:32px;
  height:32px;
  border-radius:50%;
 
  border:none;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  box-shadow:0 2px 8px rgba(0,0,0,0.15);
  padding:0;
  z-index:11;
}


  .wl-btn-cart-icon svg{
  stroke:#000 !important;
}
    .wishlist-icon {
  fill: #ece8e8ff;
  stroke: #e0ccccff;
  stroke-width: 2;
}

.wishlist-icon.active {
  fill: #e74c3c;
  stroke: #e74c3c;
}
  .wishlist-card-btn {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

   #wishlist-container .wl-card__inner{
   width:100% !important;
   }  
.wishlist-card-btn:hover {
  color: #e74c3c !important;
  
  transform: none !important;
  opacity: 1 !important;
  box-shadow: none !important;
}
    #wishlist-container { 
      width: 100% !important;
      max-width: 100% !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      box-sizing: border-box !important;
    }
    #shopify-section-template--19852424413346__main h1 {
      text-align: center !important;
      color: black !important;
    }
    #shopify-section-template--19852424413346__main a[style*="background:#3498db"],
    #shopify-section-template--19852424413346__main a[style*="background: #3498db"] {
      background: #2d5e34 !important;
    }



@media screen and (max-width: 749px) {
  .wishlist-icon path {
  fill: #ece8e8ff;
  stroke: #e0ccccff;
  stroke-width: 2;
}

.wishlist-icon.active path {
  fill: #e74c3c;
  stroke: #e74c3c;
}
}
  @media screen and (min-width: 749px) {
  .wl-card__inner img{
  width:100%;
  height:100%;
  object-fit:cover;
  object-position:center top;
  display:block;
  transform:scale(1.1);
}
  @media screen and (min-width: 750px){
  .wl-sold-out-badge{
    margin-left: 10px !important;
  }
}
  
}


  @media screen and (max-width: 749px) {
  .page-width.page-width--narrow,
  .template-page .page-width,
  .template-page .page-width--narrow,
  #shopify-section-template--19852424413346__main,
  #shopify-section-template--19852424413346__main > div {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  #wishlist-container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  #wishlist-container .wl-grid {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 4px !important;
    width: 210% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  #wishlist-container .wl-card-wrapper {
    width: 100% !important;
    min-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  #wishlist-container .wl-card {
    width: 100% !important;
    min-width: 0 !important;
  }

  #shopify-section-template--19852424413346__main h1 {
    font-size: 28px !important;
    margin: 15px 0 12px !important;
  }
}
 @media screen and (min-width: 750px) {
  #wishlist-container .wl-heart-btn {
    right: 25px !important;
    left: auto !important;
  }
    #wishlist-container .wl-btn-cart-icon{
    left: 45px !important;
    right: auto !important;
    }
}
  `;
  const style = document.createElement('style');
  style.id = 'wishlist-dynamic-styles';
  style.textContent = css;
  document.head.appendChild(style);
})();

import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js';
import { getFirestore, collection, query, where, onSnapshot, doc, runTransaction } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js';

console.log('🔥 Wishlist Firebase loaded');

const firebaseConfig = {
  apiKey: "AIzaSyCDJ-h56o9g-dfLxAFugUJCgB0OlhZyZ0I",
  authDomain: "wishlist-store.firebaseapp.com",
  projectId: "wishlist-store",
  storageBucket: "wishlist-store.firebasestorage.app",
  messagingSenderId: "418660732750",
  appId: "1:418660732750:web:b53ed8453737e56142181f",
  measurementId: "G-NVZQRTWPG8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

let userId = localStorage.getItem('wishlist_user_id') || crypto.randomUUID();
localStorage.setItem('wishlist_user_id', userId);
window.userId = userId;
window.wishlistMap = {};

// Pre-paint buttons from cached wishlist before Firebase responds
const cachedWishlist = JSON.parse(localStorage.getItem('wishlist_cache') || '{}');
const isMobilePre = window.innerWidth <= 768;
const size = isMobilePre ? 18 : 22;

document.querySelectorAll('.wishlist-main-btn, .wishlist-card-btn').forEach(btn => {
  const id = String(btn.dataset.id);
  const isActive = !!cachedWishlist[id];
  btn.innerHTML = `<svg class="wishlist-icon ${isActive ? 'active' : ''}" xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </svg>`;
  btn.style.visibility = 'visible';
});

window.initWishlist = function() {
  console.log('🚀 Initializing wishlist for user:', userId);
  const q = query(collection(db, 'wishlist'), where('userId', '==', userId));
  window.unsubscribe = onSnapshot(q, (snapshot) => {
    console.log('📱 Got', snapshot.size, 'wishlist items');
    window.wishlistMap = {};
    snapshot.forEach((docSnap) => {
      const data = docSnap.data();
      window.wishlistMap[data.productId] = data;
    });
    localStorage.setItem('wishlist_cache', JSON.stringify(window.wishlistMap));
    window.updateAllButtons();
    renderWishlistIfNeeded();
    setTimeout(() => window.updateAllButtons(), 200);
  });
};
window.toggleWishlist = async function(productId) {
  console.log('🔄 Toggling product:', productId);
  const btn = document.querySelector(`.wishlist-main-btn[data-id="${productId}"], .wishlist-card-btn[data-id="${productId}"]`);
  if (!btn) {
    console.error('❌ Button not found for:', productId);
    return;
  }
  const docId = `${userId}_${productId}`;
  try {
    await runTransaction(db, async (transaction) => {
      const docRef = doc(db, 'wishlist', docId);
      const docSnap = await transaction.get(docRef);
      if (docSnap.exists()) {
        transaction.delete(docRef);
        console.log('🗑️ Removed');
      } else {
        const productData = {
          userId,
          productId: String(productId),
          name: btn.dataset.title || 'Product',
          image: btn.dataset.image || '',
          handle: btn.dataset.handle || 'product-' + productId,
          price: btn.dataset.price || '₹999'
        };
        transaction.set(docRef, productData);
        console.log('➕ Added:', productData.name);
      }
    });
  } catch(e) {
    console.error('❌ Error:', e);
  }
};

window.updateAllButtons = function() {
  const isMobile = window.innerWidth <= 768;
  const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;

  document.querySelectorAll('.wishlist-main-btn').forEach(btn => {
    btn.removeAttribute('onclick');
    btn.style.pointerEvents = 'auto';
    btn.style.zIndex = '999';
    btn.style.position = 'relative';
    const id = String(btn.dataset.id);
    const isActive = !!window.wishlistMap[id];
     btn.innerHTML = `
  <svg class="wishlist-icon ${isActive ? 'active' : ''}" xmlns="http://www.w3.org/2000/svg" width="${isMobile ? 18 : 22}" height="${isMobile ? 18 : 22}" viewBox="0 0 24 24">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </svg>
`;
    btn.style.background = 'none';
    btn.style.border = 'none';
    btn.style.boxShadow = 'none';
    btn.style.padding = '0';
    btn.style.width = 'auto';
    btn.style.height = 'auto';
    btn.style.cursor = 'pointer';
    btn.style.color = isActive ? '#d4525dff' : 'inherit';
    btn.style.fontWeight = 'bold';
    
    btn.style.transition = 'transform 0.2s ease';
    btn.style.flexShrink = '0';
    btn.style.lineHeight = '1';
    if (isMobile) {
      btn.style.fontSize = '18px';
      btn.style.background = 'none';
      btn.style.marginLeft = '6px';
      btn.style.marginTop = '14px';
    } else if (isTablet) {
      btn.style.fontSize = '22px';
      btn.style.background = 'none';
      btn.style.marginLeft = '8px';
      btn.style.marginTop = '2px';
    } else {
      btn.style.fontSize = '22px';
      btn.style.background = 'none';
      btn.style.marginLeft = '10px';
      btn.style.marginTop = '0px';
    }
    btn.classList.toggle('active', isActive);
  });

  document.querySelectorAll('.wishlist-card-btn').forEach(btn => {
    const id = String(btn.dataset.id);
    const isActive = !!window.wishlistMap[id];
    btn.innerHTML = `
  <svg class="wishlist-icon ${isActive ? 'active' : ''}" xmlns="http://www.w3.org/2000/svg" width="${isMobile ? 18 : 22}" height="${isMobile ? 18 : 22}" viewBox="0 0 24 24">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </svg>
`;
    if (isMobile) {
      btn.style.fontSize = '18px';
      btn.style.marginTop = '4px';
      btn.style.marginLeft = '6px';
    } else {
      btn.style.fontSize = '22px';
      btn.style.marginTop = '5px';
      btn.style.marginLeft = '10px';
    }
    btn.style.borderRadius = '14px';
    btn.style.padding = '0px';
   
    btn.style.fontWeight = 'bold';
  });
 document.querySelectorAll('.wishlist-main-btn, .wishlist-card-btn').forEach(btn => {
    btn.style.visibility = 'visible';
  });
};

const cartIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a69c9cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="12" y1="10" x2="12" y2="16"/><line x1="9" y1="13" x2="15" y2="13"/></svg>';

async function renderWishlistIfNeeded() {
  const container = document.getElementById('wishlist-container');
  if (!container) return;

  const emptyMsg = document.getElementById('wishlist-empty');
  const items = Object.values(window.wishlistMap);

  console.log('🔍 renderWishlistIfNeeded — items:', items.length, items);

  if (items.length === 0) {
    container.innerHTML = '';
    if (emptyMsg) emptyMsg.style.display = 'block';
    return;
  }

  if (emptyMsg) emptyMsg.style.display = 'none';
  container.innerHTML = '<p style="text-align:center;color:#888;padding:40px 0;">Loading your wishlist...</p>';

  const productDataList = await Promise.all(
    items.map(async (item) => {
      const handleToTry = item.handle || ('product-' + item.productId);
      try {
        const res = await fetch('/products/' + handleToTry + '.js');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const product = await res.json();
        console.log('✅ Fetched:', handleToTry, '| available:', product.available);
        return { ...item, shopifyProduct: product };
      } catch (e) {
        console.warn('⚠️ Fetch failed for handle:', handleToTry, e.message);
        return { ...item, shopifyProduct: null };
      }
    })
  );

  const formatPrice = function(price) {
    return 'Rs. ' + (parseFloat(price) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  };

  const cards = productDataList.map(function(item) {
    const p = item.shopifyProduct;

    // Fallback: render from Firebase stored data if Shopify fetch failed
    if (!p) {
      return '<li class="wl-card-wrapper">' +
        '<div class="wl-card">' +
          '<div class="wl-card__inner">' +
            '<a href="/products/' + (item.handle || '') + '">' +
              '<img src="' + (item.image || '') + '" alt="' + (item.name || '') + '" loading="lazy">' +
            '</a>' +
            '<button type="button" class="wishlist-card-btn wl-heart-btn"' +
              ' data-id="' + item.productId + '"' +
              ' data-title="' + (item.name || '') + '"' +
              ' data-image="' + (item.image || '') + '"' +
              ' data-handle="' + (item.handle || '') + '"' +
              ' data-price="' + (item.price || '') + '"' +
            '>❤️</button>' +
          '</div>' +
          '<div class="wl-card__content">' +
            '<h3 class="wl-card__heading"><a href="/products/' + (item.handle || '') + '">' + (item.name || 'Product') + '</a></h3>' +
            '<div class="wl-price-wrap"><span class="wl-price-regular">' + (item.price || '') + '</span></div>' +
          '</div>' +
        '</div>' +
      '</li>';
    }

    const isSoldOut = !p.available;
    const firstVariant = p.variants[0];
    const variantId = firstVariant.id;
    const hasDiscount = firstVariant.compare_at_price &&
      parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price);

    const image = p.featured_image || (p.images && p.images[0]) || item.image;

    const soldOutBadge = isSoldOut
      ? '<span class="wl-sold-out-badge">Sold Out</span>'
      : '';

    const priceHtml = hasDiscount
      ? '<span class="wl-price-compare">' + formatPrice(firstVariant.compare_at_price) + '</span>' +
        '<span class="wl-price-sale">' + formatPrice(firstVariant.price) + '</span>'
      : '<span class="wl-price-regular">' + formatPrice(firstVariant.price) + '</span>';

    const actionBtns = isSoldOut
      ? '<button class="wl-btn-soldout" disabled>Sold Out</button>'
      : '<button class="wl-btn-cart-icon" data-variant-id="' + variantId + '" onclick="event.stopPropagation(); window.addToCart(' + variantId + ', this);" title="Add to cart">' +
          cartIconSVG +
        '</button>';

    return '<li class="wl-card-wrapper">' +
      '<div class="wl-card">' +
        '<div class="wl-card__inner">' +
          '<a href="/products/' + p.handle + '">' +
            '<img src="' + image + '" alt="' + p.title + '" loading="lazy">' +
          '</a>' +
         soldOutBadge +
          '<div class="wl-cart-overlay" onclick="event.stopPropagation();">' + actionBtns + '</div>' +
          '<button type="button" class="wishlist-card-btn wl-heart-btn"' +
            ' data-id="' + item.productId + '"' +
            ' data-title="' + p.title + '"' +
            ' data-image="' + image + '"' +
            ' data-handle="' + p.handle + '"' +
            ' data-price="' + formatPrice(firstVariant.price) + '"' +
          '>🤍</button>' +
        '</div>' +
        '<div class="wl-card__content">' +
          '<h3 class="wl-card__heading"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
          '<div class="wl-price-wrap">' + priceHtml + '</div>' +
          '</div>' +
      '</div>' +
    '</li>';
  });

  container.innerHTML = [
    '<style>',
    '*{box-sizing:border-box;}',
   '.wl-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;width:100%;list-style:none;padding:0;margin:0;box-sizing:border-box;}',
'.wl-card-wrapper{width:100%;min-width:0;box-sizing:border-box;}',
'.wl-card{width:100%;min-width:0;box-sizing:border-box;}',
    '@media(min-width:750px){.wl-grid{grid-template-columns:repeat(4,1fr);gap:20px;}}',
    '@media(min-width:750px) and (max-width:1024px){.wl-grid{grid-template-columns:repeat(3,1fr);gap:16px;}}',
    '.wl-card-wrapper{position:relative;width:100%;}',
    '.wl-card{background:none;overflow:hidden;display:flex;flex-direction:column;position:relative;height:100%;}',
    '.wl-card__inner{position:relative;width:100%;aspect-ratio:3/4;overflow:hidden;}',
    '.wl-card__inner a{display:block;width:100%;height:100%;margin-left:0;}',
    '.wl-card__inner img{width:100%;height:100%;object-fit:cover;object-position:center top;display:block;margin-left:0;}',
    '.wl-sold-out-badge{position:absolute;top:8px;left:8px;background:#fff;color:black;z-index:9999;border-radius:30px;padding:4px 10px;font-size:11px;border:1px solid black;}',
    '.wl-heart-btn{position:absolute;top:8px;right:8px;width:30px;height:30px;border-radius:50%;background:none;border:none;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.15);z-index:5;padding:0;}',
    '@media screen and (min-width: 750px){.wl-heart-btn{position:absolute;top:8px;left:18px; right:auto;  width:30px;height:30px;border-radius:50%;background:none;border:none;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.15);z-index:5;padding:0;}}',
    '.wl-card__content{padding:6px 4px 10px;display:flex;flex-direction:column;flex:1;}',
    '.wl-card__heading{font-size:12px;font-weight:600;margin:0 0 4px;line-height:1.3;word-break:break-word;}',
    '.wl-card__heading a{text-decoration:none;color:#222;}',
    '.wl-price-wrap{display:flex;align-items:center;gap:6px;margin-bottom:4px;flex-wrap:wrap;}',
    '.wl-price-compare{font-size:11px;color:#999;text-decoration:line-through;font-style:italic;}',
    '.wl-price-sale{font-size:12px;font-weight:700;color:#222;}',
    '.wl-price-regular{font-size:12px;color:#222;}',
    '.wl-btn-cart-icon{width:32px;height:32px;border-radius:50%;background:#fff;border:none;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.15);padding:0;transition:transform 0.2s ease;}',
    '.wl-btn-cart-icon:hover{transform:translateY(-2px);}',
    '.wl-btn-cart-icon svg{pointer-events:none;}',
    '.wl-btn-cart-icon.added svg{stroke:#000;}',
    '.wl-btn-soldout{position:absolute;bottom:8px;right:8px;height:26px;padding:0 10px;background:#e0e0e0;color:#999;border:none;border-radius:10px;font-size:10px;cursor:not-allowed;display:inline-flex;align-items:center;justify-content:center;}',
    '</style>',
    '<ul class="wl-grid">',
    cards.join(''),
    '</ul>'
  ].join('');

  setTimeout(() => window.updateAllButtons(), 100);
}

// Add to cart — SVG button safe version
window.addToCart = async function(variantId, btn) {
  btn.classList.add('adding');
  btn.style.pointerEvents = 'none';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error('Failed');
    const item = await res.json();

    btn.classList.remove('adding');
    btn.classList.add('added');

    // Update cart count bubble
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('.cart-count-bubble').forEach(el => {
        const span = el.querySelector('span[aria-hidden]');
        if (span) span.textContent = cart.item_count;
        else el.textContent = cart.item_count;
      });
    });  

    // Use your existing custom popup — already defined in theme.liquid
    if (typeof showCustomCartPopup === 'function') {
      showCustomCartPopup(item.title);
    }

    setTimeout(() => {
      btn.classList.remove('added');
      btn.style.pointerEvents = 'auto';
    }, 2000);

  } catch(e) {
    btn.classList.remove('adding');
    btn.style.pointerEvents = 'auto';
    console.error('Add to cart error:', e);
  }
};
window.buyNow = async function(variantId) {
  try {
    await fetch('/cart/clear.js', { method: 'POST' });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    window.location.href = '/checkout';
  } catch(e) {
    console.error('Buy now error:', e);
    window.location.href = '/cart';
  }
};

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.wishlist-main-btn, .wishlist-card-btn');
  if (btn) {
    e.preventDefault();
    window.toggleWishlist(btn.dataset.id);
  }
}, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.initWishlist);
} else {
  window.initWishlist();
}

console.log('✅ Wishlist ready!');